export default __webpack_public_path__ + "027a565eab208a8fbb74664602ce627a.png";